// extracted by mini-css-extract-plugin
export var divider = "_wu-0";